module.exports = __webpack_public_path__ + "static/img/gz_11.bbdfb26.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gz_11.jpg
// module id = hfMp
// module chunks = 0